import { guestLinkNameValidator as guestLinkNameZodValidator } from '@lucidlink/dto/validation';
import { remapZodErrors } from '@lucidlink/uicore';
export const guestLinkNameValidator = (value) => {
    const res = guestLinkNameZodValidator.safeParse(value?.trim());
    return {
        isValid: res.success,
        errors: res.success ? [] : remapZodErrors(res.error.issues),
    };
};
